import { TraceXInterceptor } from '@trace-x/trace-x-generator';
// tslint:disable:variable-name
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TariffSearchResultService } from '../services/tariff-search-result.service';
import { TariffResultTable, TariffResultTableState } from '../models/result-table';
import { DataShareService, SurfFilterOptionTooltipValueEnum } from '@surf/surf-components-core';
import { SurfTariffSearchService } from '../surf-tariff-search.service';
import { TariffApiService } from '../services/tariff-api.service';
import { Utils } from '../utils/utils';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'surf-tariff-search-results',
  templateUrl: './tariff-search-results.component.html',
})
export class TariffSearchResultsComponent implements OnInit, OnChanges {

  @Input() componentId = '';
  @Input() resultList;
  resultLoader = false;

  modifiedResultList: any[];
  allDataSelected = false;
  selectedDownloadOption: 'PDF' | 'EXCEL' = 'PDF';
  downloadOptions = [
    { id: 'PDF', label: 'PDF', selected: true },
    { id: 'EXCEL', label: 'Excel', selected: false },
  ];

  keyParams: string;

  // randomly generate below id
  checkboxId = Utils.generateRandomId(true);

  SurfFilterOptionTooltipValueEnum = SurfFilterOptionTooltipValueEnum;

  constructor(
    private tariffSearchResultService: TariffSearchResultService,
    private surfTariffSearchService: SurfTariffSearchService,
    private tariffApiService: TariffApiService,
    private dataShare: DataShareService,
  ) { }

  get sortBy(): string {
    return this.tariffSearchResultService.sortBy;
  }

  set sortBy(value: string) {
    this.tariffSearchResultService.sortBy = value;
  }

  get sortDirection(): 'neutral' | 'asc' | 'desc' {
    return this.tariffSearchResultService.sortDirection;
  }

  set sortDirection(value: 'neutral' | 'asc' | 'desc') {
    this.tariffSearchResultService.sortDirection = value;
  }

  get pageNumber(): number {
    return this.tariffSearchResultService.pageNumber;
  }

  set pageNumber(value: number) {
    this.tariffSearchResultService.pageNumber = value;
  }

  get pageSize(): number {
    return this.tariffSearchResultService.pageSize;
  }

  set pageSize(value: number) {
    this.tariffSearchResultService.pageSize = value;
  }

  get hasMore(): boolean {
    return this.tariffSearchResultService.hasMoreResults;
  }

  set hasMore(value: boolean) {
    this.tariffSearchResultService.hasMoreResults = value;
  }

  ngOnInit(): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.ngOnInit');
    this.surfTariffSearchService.getLoadingResult().subscribe((loading) => {
      this.resultLoader = loading;
    });

    this.dataShare.getKeyParamString().subscribe((keyParams) => {
      if (keyParams) {
        this.keyParams = keyParams;
      }
    });

  }

  ngOnChanges(changes): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.ngOnChanges');
    this.modifiedResultList = this.tariffSearchResultService.modifyResultList(this.resultList);
    // if (changes.resultList) {
    //   console.log(this.modifiedResultList);
    //   this.modifiedResultList = this.tariffSearchResultService.modifyResultList(this.resultList);
    // }
  }

  toggleAllSelection(): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.toggleAllSelection');
    this.allDataSelected = !this.allDataSelected;
    // should only select the current page records of the table
    for (const item of [...this.modifiedResultList.slice((this.pageNumber - 1) * this.pageSize, this.pageNumber * this.pageSize)]) {
      item.selected = this.allDataSelected;
    }
  }

  toggleSelection(record: any): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.toggleSelection');
    record.selected = !record.selected;

    if (!record.selected) {
      this.allDataSelected = false;
    }

    if (this.getSelectedCount() === 0) {
      this.allDataSelected = false;
    }

    if (this.getSelectedCount() === this.modifiedResultList.length) {
      this.allDataSelected = true;
    }
  }

  sortResults(): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.sortResults');
    this.modifiedResultList = this.tariffSearchResultService.sortResults(this.modifiedResultList);
  }

  sortByHandler(sortByHeader: keyof TariffResultTable, event: MouseEvent): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.sortByHandler');
    // if the click is on the select all checkbox, do not sort
    if (event) {
      let element = event?.target as Element;
      while (element) {
        if (element.classList.contains(this.checkboxId)) {
          return;
        }
        element = element.parentElement;
      }
    }
    this.sortBy = sortByHeader;
    if (this.sortDirection === 'neutral') {
      this.sortDirection = 'asc';
    } else if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc';
    } else if (this.sortDirection === 'desc') {
      this.sortDirection = 'asc';
    }

    this.sortResults();
  }

  getSelectedCount(): number {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.getSelectedCount');
    const selectedCount = this.getSelectedItems()?.length;

    if (
      selectedCount ===
      this.modifiedResultList.slice(
        (this.pageNumber - 1) * this.pageSize,
        this.pageNumber * this.pageSize
      ).length
    ) {
      this.allDataSelected = true;
    } else {
      this.allDataSelected = false;
    }
    return selectedCount;
  }

  getSelectedItems(): any[] {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.getSelectedItems');
    return this.modifiedResultList.filter((result) => result.selected);
  }

  downloadSelected(): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.downloadSelected');
    this.tariffApiService.downloadTariffHotelResultsFile(
      this.keyParams,
      this.getSelectedItems(),
      this.selectedDownloadOption
    );
  }

  onPageChange(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.onPageChange');
    // to prevent animation overlap
    setTimeout(() => {
      this.pageNumber = event;
    }, 10);

    if (event) {
      // clear the selected items
      this.allDataSelected = false;
      this.modifiedResultList.forEach((result) => {
        result.selected = false;
      });
    }
  }

  toggleState(event, value: 'PDF' | 'EXCEL') {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.toggleState');
    this.selectedDownloadOption = event.id;
    this.downloadOptions.forEach((option) => {
      option.selected = event.id === option.id;
    });
  }

  onClickDownload(record, type: 'PDF' | 'EXCEL') {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/tariff-search-results/tariff-search-results.component.ts.TariffSearchResultsComponent.onClickDownload');
    this.tariffApiService.downloadTariffHotelResultsFile(
      this.keyParams,
      [record],
      type
    );
  }

  // loadMore(event: boolean) {
  //   this.pageNumber++;
  //   if (event === true && this.hasMore) {
  //     this.tariffApiService.searchTariffHotelCriteria(
  //       this.surfTariffSearchService.getTariffHotelCriteriaValue(),
  //       this.keyParams,
  //     );
  //   }
  // }
}
